import axios from "axios";
import { API_URL } from "../../../setup/config/env";

export const fetchSavedQRs = async () => {
    try {
        const response = await axios.get(`${API_URL}/api/qr/saved`);
        return response.data;
    } catch (error) {
        console.error("Error fetching saved QR codes:", error);
        throw error;
    }
};